import { Component, Input } from '@angular/core';
import { DateFormat, StatusColor } from '@lsq-frontend/common-ui';
import { Icons } from '@lsq-frontend/common-ui';
import { LsqGroupedDataTableComponent, TotalsRowKeyPair } from '@lsq-frontend/common-ui';
import { PopoverPlacement } from 'ngx-smart-popover';
import { EnumDisplay } from '../../../../../constants/enum-display.constants';
import {
    Purchase,
    PurchaseStatus
} from '@lsq-frontend/remote-services/enterprise/dashboard-services';

@Component({
    selector: 'purchases-by-customer-grouped-table',
    templateUrl: './purchases-by-customer.grouped-table.component.html',
    styleUrls: ['./purchases-by-customer.grouped-table.component.scss']
})
export class PurchasesByCustomerGroupedTableComponent extends LsqGroupedDataTableComponent {
    @Input() public debtorKey: number;

    // Constants.
    public dateFormat = DateFormat;
    public enumDisplay = EnumDisplay;
    public icons = Icons;
    public placement = PopoverPlacement;
    public purchaseStatus = PurchaseStatus;
    public statusColor = StatusColor;

    public isRowExpandable(row: Purchase): boolean {
        return row.status !== 'Submitted';
    }

    public setTotalsRowKeyPairs(): TotalsRowKeyPair[] {
        return undefined;
    }
}
